/**
 * Sentinel stored in `filters.vehicleType` meaning "no ACTIVE vehicle type
 * attached". Mutually exclusive with uuid selections; the param builder maps
 * it to `no_vehicle_type: true` instead of `vehicle_type_uuid`.
 */
export const NO_VEHICLE_TYPE_FILTER = "none";

export type VehicleFilters = {
  search?: string | null;
  // ownedBy?: string | null;
  // identifier?: string | null;
  color?: string[] | null;
  engineType?: string[] | null;
  make?: string | null;
  model?: string | null;
  minCapacityPax?: number | null;
  // maxCapacityPax?: number | null;
  minCapacityBags?: number | null;
  // maxCapacityBags?: number | null;
  minYear?: number | null;
  // maxYear?: number | null;
  isRegistrationVerified?: string | null;
  // isArchived?: boolean | null;
  vehicleCategory?: string[] | null;
  vehicleType?: string[] | null;
  state?: string[] | null;
};
